import { render, staticRenderFns } from "./eclaim.vue?vue&type=template&id=04d81b4c"
import script from "./eclaim.vue?vue&type=script&lang=js"
export * from "./eclaim.vue?vue&type=script&lang=js"
import style0 from "./eclaim.vue?vue&type=style&index=0&id=04d81b4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports